<template lang="html">
  <div class="calendar-wrapper">
    <chooseStore
      v-model="store"
      :cityCode="params.cityId || 320100"
      :selectedId="params.selectedId || ''"
    ></chooseStore>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import chooseStore from '../chooseStore'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      store: {}
    }
  },
  components: {
    chooseStore
  },
  computed: {
    ...mapState(['nearbyStore'])
  },
  watch: {
    store(val) {
      this.setNearbyStore(val)
      this.hideActionSheet()
    }
  },
  methods: {
    ...mapMutations(['setNearbyStore', 'hideActionSheet'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.calendar-wrapper {
  min-height: 100%;
  // padding-bottom: rem(100px);
}
.date-prompt-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: rem(20px) rem(55px);
  z-index: 20;
  background: #f4f4f4;

  .date-prompt {
    @include border(all, #e6e6e6, 1px, 4px);
  }
}
</style>
